import React, { useState } from "react";
import "./SchoolReportDashboard.css";

/* =========================================================
   BANNER IMAGES
========================================================= */
import slider1 from "../../src/assets/School.jpg";


/* =========================================================
   REPORT ICON FALLBACK
   FontAwesome available hone par icons show honge.
========================================================= */
const reportCards = [
  {
    id: 1,
    title: "School in Rajasthan",
    href: null,
    icon: "fa fa-university",
    activeIcon: "fa fa-university",
    action: "popup",
  },
  {
    id: 2,
    title: "Model Schools",
    href: "",
    icon: "fa fa-graduation-cap",
    activeIcon: "fa fa-graduation-cap",
  },
  {
    id: 3,
    title: "MGSS",
    href: "",
    icon: "fa fa-book",
    activeIcon: "fa fa-book",
  },
  {
    id: 4,
    title: "Under Adarsh Scheme Schools",
    href: "",
    icon: "fa fa-certificate",
    activeIcon: "fa fa-certificate",
  },
  {
    id: 5,
    title: "Under Utkristh Scheme Schools",
    href: "",
    icon: "fa fa-award",
    activeIcon: "fa fa-award",
  },
  {
    id: 6,
    title: "CWSN Resource Centre Count",
    href: "",
    icon: "fa fa-heart",
    activeIcon: "fa fa-heart",
  },
  {
    id: 7,
    title: "KGBVs/KGBV Hostels in Schools",
    href: "",
    icon: "fa fa-pencil",
    activeIcon: "fa fa-pencil",
  },
  {
    id: 8,
    title: "Residential Schools",
    href: "",
    icon: "fa fa-home",
    activeIcon: "fa fa-home",
  },
];

/* =========================================================
   DATA
========================================================= */
const managementData = [
  {
    id: 96,
    name: "Swami Vivekananda Model School",
    count: 134,
  },
  {
    id: 1,
    name: "Department of Education",
    count: 21391,
  },
  {
    id: 2,
    name: "Tribal/Social Welfare Dept.",
    count: 3157,
  },
  {
    id: 3,
    name: "Local body/Panchayati Raaj",
    count: 43161,
  },
  {
    id: 97,
    name: "Madarsa recognized (by Wakf board/Madarsa Board)",
    count: 2850,
  },
  {
    id: 11,
    name: "Sanskrit Education",
    count: 1871,
  },
  {
    id: 15,
    name: "KGBVS & KGBV HOSTELS",
    count: 178,
  },
  {
    id: 17,
    name: "MEWAT",
    count: 10,
  },
  {
    id: 20,
    name: "Department of Minority Affairs",
    count: 32,
  },
  {
    id: 18,
    name: "Residential",
    count: 7,
  },
];

const categoryData = [
  {
    id: 1,
    name: "1-5",
    count: 34236,
  },
  {
    id: 2,
    name: "1-8",
    count: 17688,
  },
  {
    id: 3,
    name: "1-12",
    count: 20288,
  },
  {
    id: 4,
    name: "6-8",
    count: 213,
  },
  {
    id: 5,
    name: "6-12",
    count: 288,
  },
  {
    id: 6,
    name: "1-10",
    count: 22,
  },
  {
    id: 10,
    name: "9-12",
    count: 56,
  },
];

const typeData = [
  {
    id: 3,
    name: "Girls",
    count: 2601,
  },
  {
    id: 1,
    name: "CO-ED",
    count: 70124,
  },
  {
    id: 2,
    name: "Boys",
    count: 67,
  },
];

/* =========================================================
   IMAGE WITH FALLBACK ICON
========================================================= */
const SafeImage = ({
  src,
  alt = "",
  fallbackIcon = "fa fa-image",
  className = "",
}) => {
  const [imageError, setImageError] = useState(false);

  if (imageError || !src) {
    return (
      <span
        className={`srd-image-fallback ${className}`}
        aria-label={alt || "Report icon"}
      >
        <i className={fallbackIcon} aria-hidden="true" />
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setImageError(true)}
    />
  );
};

/* =========================================================
   REPORT CARD
========================================================= */
const ReportCard = ({ item, onPopup }) => {
  const handleClick = (event) => {
    if (item.action === "popup") {
      event.preventDefault();
      onPopup();
    }
  };

  const cardContent = (
    <>
      <div className="firtsDiv">
        <figure>
          <SafeImage
            src={null}
            alt={item.title}
            fallbackIcon={item.icon}
          />
        </figure>

        <figcaption className="slidein">
          <p>{item.title}</p>
        </figcaption>
      </div>

      <div className="secondDiv">
        <figure>
          <span className="srd-hover-icon">
            <i className={item.activeIcon} aria-hidden="true" />
          </span>
        </figure>

        <figcaption className="slidein">
          <p>{item.title}</p>
        </figcaption>
      </div>
    </>
  );

  if (item.href) {
    return (
      <div className="item sweep-to-top">
        <a
          href={item.href}
          target="_blank"
          rel="noreferrer"
          className="srd-card-link"
        >
          {cardContent}
        </a>
      </div>
    );
  }

  return (
    <div
      className="item sweep-to-top active"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleClick(event);
        }
      }}
    >
      {cardContent}
    </div>
  );
};

/* =========================================================
   TABLE COMPONENT
========================================================= */
const ReportTable = ({ title, data, type }) => {
  return (
    <>
      <div className="srd-section-heading">
        <span className="srd-heading-icon">
          <i
            className={
              type === "management"
                ? "fa fa-sitemap"
                : type === "category"
                ? "fa fa-layer-group"
                : "fa fa-users"
            }
            aria-hidden="true"
          />
        </span>

        <h2>{title}</h2>
      </div>

      <div className="table-responsive srd-table-wrapper">
        <table className="table table-striped table-bordered text-left SchoolinRajasthan">
          <thead>
            <tr>
              <th>Name</th>
              <th>Total School</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>
                  <a
                    href=""
                    onClick={() => console.log("getid", item.id, type)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.name}
                  </a>
                </td>

                <td>
                  <span className="srd-count">{item.count}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

/* =========================================================
   MAIN COMPONENT
========================================================= */
const SchoolReportDashboard = () => {
  const [showSchoolPopup, setShowSchoolPopup] = useState(false);
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  const [currentSlider, setCurrentSlider] = useState(0);

  const sliderImages = [slider1];

  /* =======================================================
     SLIDER
  ======================================================= */
  const handleSliderError = () => {
    setCurrentSlider((prev) =>
      prev + 1 < sliderImages.length ? prev + 1 : 0
    );
  };

  /* =======================================================
     POPUP
  ======================================================= */
  const openSchoolPopup = () => {
    setShowSchoolPopup(true);
    document.body.classList.add("srd-modal-open");
  };

  const closeSchoolPopup = () => {
    setShowSchoolPopup(false);
    document.body.classList.remove("srd-modal-open");
  };

  const closeInfoPopup = () => {
    setShowInfoPopup(false);
    document.body.classList.remove("srd-modal-open");
  };

  /* =======================================================
     RETURN
  ======================================================= */
  return (
    <div className="srd-page">
      {/* =====================================================
          HERO
      ===================================================== */}
      <div className="srd-banner" id="divbanner">
        <section className="hero_banner">
          <figure>
            <SafeImage
              src={sliderImages[currentSlider]}
              alt="School Reports Banner"
              fallbackIcon="fa fa-school"
              className="srd-hero-image"
            />

            <div className="srd-hero-overlay" />

            <div className="srd-hero-content">
              <span className="srd-hero-badge">
                <i className="fa fa-graduation-cap" />
                Rajasthan Education
              </span>

              <h2>School Reports</h2>

              <p>
                Explore school information, schemes and educational reports
              </p>
            </div>

            <div className="srd-slider-dots">
              {sliderImages.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={index === currentSlider ? "active" : ""}
                  onClick={() => setCurrentSlider(index)}
                  aria-label={`Show banner ${index + 1}`}
                />
              ))}
            </div>

            {/* <button
              type="button"
              className="srd-slider-next"
              onClick={() =>
                setCurrentSlider(
                  (prev) => (prev + 1) % sliderImages.length
                )
              }
              aria-label="Next banner"
            >
              <i className="fa fa-chevron-right" />
            </button> */}
          </figure>
        </section>
      </div>

      {/* =====================================================
          MAIN
      ===================================================== */}
      <main className="srd-main">
        <div className="container">
          {/* BREADCRUMB */}
          <nav className="srd-breadcrumb-wrapper">
            {/* <ol className="breadcrumb-arrow">
              <li>
                <a href="">
                  <i className="fa fa-home" />
                  Citizen Window
                </a>
              </li>

              <li className="active">
                <a href="#school-reports">School in Rajasthan</a>
              </li>
            </ol> */}
          </nav>

          {/* PAGE TITLE */}
          <div className="srd-title-area" id="school-reports">
            <span className="srd-title-icon">
              <i className="fa fa-graduation-cap" />
            </span>

            <h1>School Reports</h1>

            <p>
              Access detailed information and reports related to schools
              across Rajasthan.
            </p>
          </div>

          {/* =================================================
              CARDS
          ================================================= */}
          <section className="srd-report-section">
            <div className="card-container" id="divsearchdashboard">
              {reportCards.map((item) => (
                <ReportCard
                  key={item.id}
                  item={item}
                  onPopup={openSchoolPopup}
                />
              ))}
            </div>
          </section>
        </div>
      </main>

      {/* =====================================================
          SCHOOL POPUP
      ===================================================== */}
      {showSchoolPopup && (
        <div
          id="getdivdetails"
          className="modal fade school_Information student_enrollment_pop_up show"
          role="dialog"
          aria-modal="true"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              closeSchoolPopup();
            }
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* HEADER */}
              <div className="modal-header">
                <div className="srd-modal-title-wrapper">
                  <span className="srd-modal-icon">
                    <i className="fa fa-university" />
                  </span>

                  <h6 className="modal-title">
                    School in Rajasthan
                  </h6>
                </div>

                <button
                  type="button"
                  className="close"
                  onClick={closeSchoolPopup}
                  aria-label="Close"
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              {/* BODY */}
              <div className="modal-body">
                <ReportTable
                  title="Management wise schools"
                  data={managementData}
                  type="management"
                />

                <ReportTable
                  title="Category wise schools"
                  data={categoryData}
                  type="category"
                />

                <ReportTable
                  title="Type wise schools"
                  data={typeData}
                  type="type"
                />
              </div>

              {/* FOOTER */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary srd-close-button"
                  onClick={closeSchoolPopup}
                >
                  <i className="fa fa-times" />
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* =====================================================
          SCHOOL INFORMATION POPUP
      ===================================================== */}
      {showInfoPopup && (
        <div
          id="divdetails"
          className="modal fade school_Information show"
          role="dialog"
          aria-modal="true"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              closeInfoPopup();
            }
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <div className="srd-modal-title-wrapper">
                  <span className="srd-modal-icon">
                    <i className="fa fa-info-circle" />
                  </span>

                  <h6 className="modal-title">
                    School Information
                  </h6>
                </div>

                <button
                  type="button"
                  className="close"
                  onClick={closeInfoPopup}
                  aria-label="Close"
                >
                  <i className="fa fa-times" />
                </button>
              </div>

              <div className="modal-body">
                <div className="school_Information_Block">
                  <div className="srd-section-heading">
                    <span className="srd-heading-icon">
                      <i className="fa fa-info" />
                    </span>

                    <h2>School Basic Information</h2>
                  </div>

                  <div className="srd-info-grid">
                    <div className="srd-info-item">
                      <span>School Name</span>
                      <strong className="lbl_Schoolname">
                        —
                      </strong>
                    </div>

                    <div className="srd-info-item">
                      <span>Shaladarpan Code</span>
                      <strong>—</strong>
                    </div>

                    <div className="srd-info-item">
                      <span>UDise Code</span>
                      <strong>—</strong>
                    </div>

                    <div className="srd-info-item">
                      <span>District</span>
                      <strong>—</strong>
                    </div>

                    <div className="srd-info-item">
                      <span>Block</span>
                      <strong>—</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary srd-close-button"
                  onClick={closeInfoPopup}
                >
                  <i className="fa fa-times" />
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* =====================================================
          LOADER
      ===================================================== */}
      <div
        id="divLoaderImage"
        className="LoaderImage"
        style={{ display: "none" }}
      />

      {/* =====================================================
          MOBILE NAV
      ===================================================== */}
      <nav className="mobile-nav d-lg-none">
        <ul>
          <li className="home-icon">
            <a href="" title="Portal Home">
              <i className="fa fa-home" aria-hidden="true" />
            </a>
          </li>

          <li>
            <a href="">
              Search Schools
            </a>
          </li>

          <li>
            <a href="">
              Search Schemes
            </a>
          </li>

          <li>
            <a href="">
              Prayas
            </a>
          </li>

          <li>
            <a href="">
              NAS Question Bank
            </a>
          </li>

          <li>
            <a href="">
              Board Exam Question Bank
            </a>
          </li>

          <li>
            <a href="">
              Suggestions from citizen
            </a>
          </li>

          <li className="drop-down">
            <a href="#reports">
              Reports
            </a>

            <ul>
              <li>
                <a href="">
                  School
                </a>
              </li>

              <li>
                <a href="">
                  Student
                </a>
              </li>

              <li>
                <a href="">
                  Staff
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <div className="mobile-nav-overly" />
    </div>
  );
};

export default  SchoolReportDashboard;